import { useContext, createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthenticationService from "../services/AuthenticationServices";
import { parseStoredUser } from "../Utils/userUtils";

const AuthContext = createContext();

const loadStoredUser = () => {
  return parseStoredUser(localStorage.getItem("user"));
};

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(loadStoredUser);
  const [token, setToken] = useState(localStorage.getItem("site") || "");
  const navigate = useNavigate();

  const loginAction = async (data) => {
    try {
      const response = await AuthenticationService.Login(data);
      if (response.data) {
        const authToken = response.data.token ?? response.data.Token;
        const profile = response.data.user ?? response.data.User;

        if (!authToken || !profile) {
          throw new Error("Invalid login response");
        }

        setUser(profile);
        setToken(authToken);
        localStorage.setItem("site", authToken);
        localStorage.setItem("user", JSON.stringify(profile));
        navigate("/", { replace: true });
        return;
      }
      throw new Error(response.message);
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const logOut = () => {
    setUser(null);
    setToken("");
    localStorage.removeItem("site");
    localStorage.removeItem("user");
    localStorage.removeItem("userName");
    localStorage.removeItem("email");
    navigate("/login", { replace: true });
  };

  return (
    <AuthContext.Provider value={{ token, user, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
